import t from "@ext/localization/locale/translate";
import type { QuestionType } from "@ext/markdown/elements/question/types";
import type { Node } from "@tiptap/pm/model";
import type { Editor } from "@tiptap/react";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuRadioGroup,
	DropdownMenuRadioItem,
	DropdownMenuTrigger,
} from "@ui-kit/Dropdown";
import { GlassToolbarButton, GlassToolbarIcon, GlassToolbarTriggerChevron } from "@ui-kit/GlassToolbar";
import { Tooltip, TooltipContent, TooltipTrigger } from "@ui-kit/Tooltip";

interface QuestionActionsProps {
	node: Node;
	editor: Editor;
	getPos: () => number;
}
const QuestionActions = ({ node, getPos, editor }: QuestionActionsProps) => {
	const requiredTooltip = t("editor.question.required");
	const typeTooltip = t("editor.question.types.name");

	const setQuestionType = (type: QuestionType) => {
		editor
			.chain()
			.focus(getPos() + 1)
			.setQuestionType(type)
			.run();
	};

	const setRequired = () => {
		editor
			.chain()
			.focus(getPos() + 1)
			.setQuestionRequired(!node.attrs.required)
			.run();
	};

	return (
		<>
			<GlassToolbarButton
				aria-label={requiredTooltip}
				aria-pressed={node.attrs.required}
				data-state={node.attrs.required ? "on" : "off"}
				onClick={setRequired}
				tooltipText={requiredTooltip}
			>
				<GlassToolbarIcon icon="check" />
			</GlassToolbarButton>
			<DropdownMenu>
				<Tooltip>
					<TooltipTrigger asChild>
						<DropdownMenuTrigger asChild>
							<GlassToolbarTriggerChevron aria-label={typeTooltip}>
								<GlassToolbarIcon icon="type" />
							</GlassToolbarTriggerChevron>
						</DropdownMenuTrigger>
					</TooltipTrigger>
					<TooltipContent sideOffset={2}>{typeTooltip}</TooltipContent>
				</Tooltip>
				<DropdownMenuContent>
					<DropdownMenuRadioGroup onValueChange={setQuestionType} value={node.attrs.type}>
						<DropdownMenuRadioItem value="many">{t("editor.question.types.many")}</DropdownMenuRadioItem>
						<DropdownMenuRadioItem value="one">{t("editor.question.types.one")}</DropdownMenuRadioItem>
						<DropdownMenuRadioItem value="text">{t("editor.question.types.text")}</DropdownMenuRadioItem>
					</DropdownMenuRadioGroup>
				</DropdownMenuContent>
			</DropdownMenu>
		</>
	);
};

export default QuestionActions;
